module.exports = __webpack_public_path__ + "static/media/received_1799604556741314.b2de5c58.jpeg";